import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, map, startWith } from 'rxjs';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { CmsValue, ListStoresParams } from 'src/app/core/stores.service';
import { UtilsService } from 'src/app/core/utils.service';
import { PLUGIN_SUPPORTED_CMS } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-stores-filter-dialog',
  templateUrl: './stores-filter-dialog.component.html',
  styleUrls: ['./stores-filter-dialog.component.scss'],
})
export class StoresFilterDialogComponent {
  filtered_cms?: Observable<{ value: string; label: string }[] | undefined>;
  stores_filters_from_group: FormGroup = this.form_service.stores_filters_from_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  supported_cms = PLUGIN_SUPPORTED_CMS;

  constructor(
    private dialog_ref: MatDialogRef<StoresFilterDialogComponent>,
    private utils_service: UtilsService,
    private form_service: FormService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {}

  ngOnInit(): void {
    this.stores_filters_from_group.reset();
    this.filtered_cms = this.stores_filters_from_group?.get(this.form_service.cms_label)?.valueChanges.pipe(
      startWith(''),
      map(value => this.filterStores(value || '')),
    );
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onApplyFiltersClick(): void {
    if (this.isFormValid()) {
      const store_id: string = this.stores_filters_from_group.get(this.form_service.store_id_label)?.value;
      const name: string = this.stores_filters_from_group.get(this.form_service.name_label)?.value;
      const status: string = this.stores_filters_from_group.get(this.form_service.status_label)?.value;
      const cms: string = this.stores_filters_from_group.get(this.form_service.cms_label)?.value;
      const vat: string = this.stores_filters_from_group.get(this.form_service.vat_label)?.value;
      const business_name: string = this.stores_filters_from_group.get(this.form_service.business_name_label)?.value;
      const sales_network_id: string = this.stores_filters_from_group.get(
        this.form_service.sales_network_id_label,
      )?.value;
      const company_id: string = this.stores_filters_from_group.get(this.form_service.company_id_label)?.value;

      const params: ListStoresParams = {
        store_id: store_id == '' ? undefined : store_id,
        name: name == '' ? undefined : name,
        status: status == '' ? undefined : (status as 'enabled' | 'disabled'),
        cms: cms == '' ? undefined : (cms as CmsValue),
        vat: vat == '' ? undefined : vat,
        business_name: business_name == '' ? undefined : business_name,
        sales_network_id: sales_network_id == '' ? undefined : sales_network_id,
        company_id: company_id == '' ? undefined : company_id,
      };
      this.dialog_ref.close({ params });
    }
  }

  onClearFiltersClick(): void {
    this.stores_filters_from_group.reset();
    this.filtered_cms = this.stores_filters_from_group?.get(this.form_service.cms_label)?.valueChanges.pipe(
      startWith(''),
      map(value => this.filterStores(value || '')),
    );
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.stores_filters_from_group);
  }

  getStoreStatusLabel(status: 'enabled' | 'disabled'): string {
    const store = { order_requirements: { is_enabled: status == 'enabled' } };
    return this.utils_service.getStoreStatusLabel(store);
  }

  filterStores(value: string | CmsValue): { value: string; label: string }[] | undefined {
    let filter_value: string = '';
    try {
      filter_value = (value as string).toLowerCase();
    } catch (e) {
      filter_value = (value as CmsValue as string).toLowerCase();
    }
    return this.supported_cms?.filter(option => {
      return option.label?.toLowerCase().includes(filter_value);
    });
  }

  displayAutocomplete(cms: CmsValue): string {
    return cms || '';
  }
}
